import React from 'react';

import { EVENT_ADDON_ITEM_TYPE } from '../../../constants/event-items';
import { getAsset } from '../../../util/assets';
import { ALBUM_SUBTYPE } from '../../../constants/albums';
import { FREEMIUM_EVENTS_META } from '../../../apps/pro/components/FreemiumEventPurchase/helpers';
import { PURCHASED_EVENT_ADDON_FEATURES } from '../../../apps/pro/services/featurePermissions/helpers';

export const EVENT_ADDON_ITEM_FEATURE_UPSELL_META = eventType => {
  return {
    [PURCHASED_EVENT_ADDON_FEATURES.qr_code_enabled]: {
      illustration: getAsset(
        `/event-addon-item-feature-illustration/qr-code-enabled/qr_code_enabled_${(
          eventType || 'custom'
        ).toLowerCase()}.png`,
      ),
      title: (
        <>
          Get <span className="text-gold">Gold</span> to unlock printable QR
          signage!
        </>
      ),
      subtitle:
        'Your guests will enjoy quick and easy uploading of their photos & videos. No app download required!',
      purchaseBtnProps: {
        id: 'popup-gold',
      },
    },
  };
};

export const EVENT_ADDON_ITEM_UPSELL_META = eventType => {
  const groupVideoLabel = [ALBUM_SUBTYPE.WEDDINGS].includes(eventType)
    ? 'Video Guestbook'
    : 'Group Video';

  const meta = FREEMIUM_EVENTS_META[eventType] ?? {};

  return {
    EVENT_ADDON_ITEM_FEATURE_UPSELL_META: EVENT_ADDON_ITEM_FEATURE_UPSELL_META(
      eventType,
    ),
    [EVENT_ADDON_ITEM_TYPE.MEMORY_BOOK]: {
      label: 'Memories Smart Slideshow',
      title: 'Walk down memory lane with a Memories Smart Slideshow',
      subtitle:
        'Easily gather old photos of the celebrated couple from others and turn them into a beautiful, chronological slideshow.',
      howItWorks: {
        header: 'How it works:',
        assetUrl: getAsset('/memory-book-how-it-works.gif'),
      },
      purchaseBtnProps: {
        id: 'popup-vgb',
      },
    },
    [EVENT_ADDON_ITEM_TYPE.GROUP_VIDEO]: {
      label: groupVideoLabel,
      title: `Gather well wishes with a ${groupVideoLabel}!`,
      subtitle:
        "Easily gather 30-second video messages from others and turn them into a memorable video montage. Memories you'll cherish forever!",
      ...(eventType === ALBUM_SUBTYPE.WEDDINGS
        ? {
            howItWorks: {
              assetUrl: getAsset('/vgb-how-it-works.gif'),
            },
          }
        : undefined),
      purchaseBtnProps: {
        id: 'popup-mss',
      },
    },
    [EVENT_ADDON_ITEM_TYPE.WALDOFIED]: {
      label: 'Gold with Live Slideshow',
      title: (
        <>
          Get <span className="text-gold">Gold</span> to unlock more features!
        </>
      ),
      subtitle:
        'Gold comes with these premium features sure to make your event memorable:',
      features:
        meta?.addonItemDetails?.[EVENT_ADDON_ITEM_TYPE.WALDOFIED]?.features ??
        [],
      purchaseBtnProps: {
        id: 'popup-gold',
      },
    },
  };
};
